import { render, staticRenderFns } from "./ShopToolKit.vue?vue&type=template&id=36721b46&scoped=true&"
import script from "./ShopToolKit.vue?vue&type=script&lang=ts&"
export * from "./ShopToolKit.vue?vue&type=script&lang=ts&"
import style0 from "./ShopToolKit.vue?vue&type=style&index=0&id=36721b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36721b46",
  null
  
)

export default component.exports